<template>
    <b-card class="col-sm-12 col-md-12 col-lg-12" v-if="!company">
      <div class="col-lg-6">
        <br />
        <h3>Moolah API Key</h3>
        <b-input v-model="apiKey"></b-input>
        <b-button @click="buildCompany" class="mt-4 mb-4" block variant="primary"
          >Authenticate</b-button
        >
      </div>
    </b-card>
</template>

<script>
export default {
  methods: {
    async buildCompany() {
      var self = this;

      var r = await self.$client.post(
        "/api/company/addCompanyFromPoyntCommand",
        { apikey: self.apiKey }
      );

      if (r.data.isSuccess) {
        location.href = "/#/admin/company/" + r.data.value.companyId;
      }
    },
  },
};
</script>

<style></style>
